/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from "react";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import {
  Button,
  Caption,
  DetailedSubheading,
  Flex,
  Link,
  Modal,
  ParagraphMd,
  SectionHeading,
  SectionSubheading,
  Title,
  YouTubeVideoPlayer,
} from "@olist/design-system";
import { ExpandOutline } from "@olist/design-system-icons";

import { STable } from "./styles";

export function CustomReactMarkdowm({
  message,
  theme,
}: {
  message: string;
  theme?: "light" | "dark";
}) {
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1(props) {
          return (
            <Title
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
            >
              {props.children}
            </Title>
          );
        },
        h2(props) {
          return (
            <SectionHeading
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
            >
              {props.children}
            </SectionHeading>
          );
        },
        h3(props) {
          return (
            <SectionSubheading
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
            >
              {props.children}
            </SectionSubheading>
          );
        },
        h4(props) {
          return (
            <DetailedSubheading
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
            >
              {props.children}
            </DetailedSubheading>
          );
        },
        p(props) {
          return (
            <ParagraphMd
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
            >
              {props.children}
            </ParagraphMd>
          );
        },
        span(props) {
          return (
            <Caption
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
            >
              {props.children}
            </Caption>
          );
        },
        button: Button,
        i(props) {
          return (
            <Caption
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
              className="italic"
            >
              {props.children}
            </Caption>
          );
        },
        b(props) {
          return (
            <Caption
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
              bold
            >
              {props.children}
            </Caption>
          );
        },
        strong(props) {
          return (
            <Caption
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
              bold
            >
              {props.children}
            </Caption>
          );
        },
        img(props) {
          if (["youtube", "embed"].some((item) => props?.src?.includes(item))) {
            const videoId = props.src?.split("v=").at(-1) || "";
            return (
              <Flex
                height="180px"
                width="320px"
                borderRadius="small"
                overflow="hidden"
              >
                <YouTubeVideoPlayer
                  onClose={() => {}}
                  thumbOption="maxresdefault"
                  onOpen={() => {}}
                  title="Video"
                  videoId={videoId}
                />
              </Flex>
            );
          }
          return <img {...props} alt="lis-images" />;
        },
        a(props) {
          if (
            ["youtube", "embed"].some((item) => props?.href?.includes(item))
          ) {
            const videoId = props.href?.split("v=").at(-1) || "";
            return (
              <Flex height="180px" width="320px">
                <YouTubeVideoPlayer
                  onClose={() => {}}
                  thumbOption="maxresdefault"
                  onOpen={() => {}}
                  title=""
                  videoId={videoId}
                />
              </Flex>
            );
          }

          return (
            <Link
              {...props}
              target="_blank"
              referrerPolicy="no-referrer"
              type="inline"
            >
              {props.children}
            </Link>
          );
        },
        ul(props) {
          return (
            <Flex
              flexDirection="column"
              paddingHorizontal="inline.small"
              gap="stack.small"
            >
              {props.children}
            </Flex>
          );
        },
        li(props) {
          return (
            <Caption
              color={theme === "dark" ? "neutral.softest" : "neutral.base"}
            >
              - {props.children}
            </Caption>
          );
        },
        table(props) {
          return (
            <Flex flexDirection="column" gap="stack.small">
              <STable>{props.children}</STable>
              <Button
                variation="secondary"
                iconLeft={ExpandOutline}
                onClick={() => setIsTableModalOpen(true)}
              >
                expandir tabela
              </Button>
              <Modal
                title=""
                isOpen={isTableModalOpen}
                onClose={() => setIsTableModalOpen(false)}
                body={
                  <Flex
                    width="100%"
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <STable>{props.children}</STable>
                  </Flex>
                }
              />
            </Flex>
          );
        },
      }}
    >
      {message}
    </ReactMarkdown>
  );
}
